// assets/a24-hero-slider-section.js
/* Extracted section logic. Liquid keeps markup/data only; this file owns behavior. */
(function () {
  'use strict';

  function init(root) {

    if (!root) return;

    var slides = root.querySelectorAll('.hero__bg-slide');
    var contents = root.querySelectorAll('.hero-slider__content');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    var alignmentContainer = root.querySelector('[data-hero-alignment-container]');
    var autoplaySetting = root.getAttribute('data-autoplay') === 'true';
    var isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
    var autoplayEnabled = autoplaySetting && !isThemeEditor;
    var intervalMs = parseInt(root.getAttribute('data-interval') || '5000', 10);
    var sliderState = window.__heroSliderState || (window.__heroSliderState = {});
    var activeIndex = 0;
    var timer = null;
    var blockIndexMap = {};
    var positionRaf = null;
    var revealRaf = null;
    var positionResizeObserver = null;

    if (!slides.length) return;

    if (typeof sliderState[root.id] === 'number') {
      activeIndex = sliderState[root.id];
    }
    if (activeIndex < 0 || activeIndex >= slides.length) {
      activeIndex = 0;
    }

    contents.forEach(function (content, index) {
      var blockId = content.getAttribute('data-block-id');
      if (blockId) {
        blockIndexMap[blockId] = index;
      }
    });

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function getViewportMode() {
      if (window.matchMedia('(max-width: 749px)').matches) return 'mobile';
      if (window.matchMedia('(max-width: 989px)').matches) return 'tablet';
      return 'desktop';
    }

    function getResponsiveValue(item, name, viewportMode, fallbackValue) {
      var responsiveValue = item.getAttribute('data-' + name + '-' + viewportMode);
      if (responsiveValue !== null && responsiveValue !== '') return responsiveValue;

      var desktopValue = item.getAttribute('data-' + name + '-desktop');
      if (desktopValue !== null && desktopValue !== '') return desktopValue;

      var legacyValue = item.getAttribute('data-' + name);
      if (legacyValue !== null && legacyValue !== '') return legacyValue;

      return fallbackValue;
    }

    function normalizeAlignmentMode(value) {
      if (value === 'left' || value === 'center' || value === 'right') return value;
      return 'manual';
    }

    function getAlignmentMode(item, viewportMode) {
      return normalizeAlignmentMode(getResponsiveValue(item, 'align', viewportMode, 'manual'));
    }

    function getOffset(item, axis, viewportMode) {
      var value = parseInt(getResponsiveValue(item, 'off-' + axis, viewportMode, '0'), 10);
      return isNaN(value) ? 0 : value;
    }

    function normalizeCtaAlignmentMode(value) {
      if (value === 'left' || value === 'center' || value === 'right') return value;
      return 'center';
    }

    function getCtaAlignmentMode(item, viewportMode) {
      return normalizeCtaAlignmentMode(getResponsiveValue(item, 'align', viewportMode, 'center'));
    }

    function getCtaAlignmentOffsetX(item, viewportMode) {
      var value = parseInt(getResponsiveValue(item, 'cta-align-off-x', viewportMode, '0'), 10);
      if (isNaN(value)) return 0;
      return clamp(Math.round(value / 6) * 6, -600, 600);
    }

    function getCtaSizeMode(item, viewportMode) {
      var sizeMode = getResponsiveValue(item, 'cta-size', viewportMode, 'medium');

      if (sizeMode !== 'xs' && sizeMode !== 'small' && sizeMode !== 'medium' && sizeMode !== 'large') {
        return 'medium';
      }

      return sizeMode;
    }

    function applyCtaSizeClass(item, viewportMode) {
      var sizeMode = getCtaSizeMode(item, viewportMode);

      item.classList.remove('hero-slider__cta-size--xs');
      item.classList.remove('hero-slider__cta-size--small');
      item.classList.remove('hero-slider__cta-size--medium');
      item.classList.remove('hero-slider__cta-size--large');
      item.classList.add('hero-slider__cta-size--' + sizeMode);
    }

    function applyTextAlignmentClass(item) {
      if (!item.classList.contains('hero-slider__title') && !item.classList.contains('hero-slider__subtitle')) return;

      var textAlignment = item.getAttribute('data-manual-text-align') || 'center';
      if (textAlignment !== 'left' && textAlignment !== 'right') {
        textAlignment = 'center';
      }

      item.classList.remove('hero-slider__text-align--left');
      item.classList.remove('hero-slider__text-align--center');
      item.classList.remove('hero-slider__text-align--right');
      item.classList.add('hero-slider__text-align--' + textAlignment);
    }

    function getTargetCenterX(mode, containerWidth, itemWidth, offsetX) {
      if (mode === 'left') return (itemWidth / 2) + offsetX;
      if (mode === 'right') return containerWidth - (itemWidth / 2) + offsetX;
      return (containerWidth / 2) + offsetX;
    }

    function applyItemPositionClass(item, alignmentMode, isCta, ctaAlignmentMode, left, top) {
      item.classList.remove(
        'hero-slider__item--positioned',
        'hero-slider__item--align-left',
        'hero-slider__item--align-center',
        'hero-slider__item--align-right'
      );
      item.classList.add('hero-slider__item--positioned');
      item.classList.add('hero-slider__item--align-' + (isCta ? ctaAlignmentMode : alignmentMode));
      item.setAttribute('data-item-left', String(left));
      item.setAttribute('data-item-top', String(top));
    }

    function scheduleReveal() {
      if (!root.classList.contains('hero-slider--positions-pending')) return;
      if (revealRaf) {
        window.cancelAnimationFrame(revealRaf);
      }

      revealRaf = window.requestAnimationFrame(function () {
        revealRaf = window.requestAnimationFrame(function () {
          revealRaf = null;
          if (!root.classList.contains('hero-slider--positions-pending')) return;
          root.classList.remove('hero-slider--positions-pending');
          root.classList.add('hero-slider--positions-ready');
        });
      });
    }

    function applyItemPositions() {
      if (!alignmentContainer) return;

      var activeContent = root.querySelector('.hero-slider__content.is-active');
      if (!activeContent) return;

      var sliderRect = root.getBoundingClientRect();
      var wrapRect = alignmentContainer.getBoundingClientRect();
      var wrapWidth = wrapRect.width || 0;
      var wrapHeight = wrapRect.height || 0;
      var viewportMode = getViewportMode();
      if (wrapWidth <= 0 || wrapHeight <= 0) return;

      activeContent.querySelectorAll('.hero-slider__item').forEach(function (item) {
        var alignmentMode = getAlignmentMode(item, viewportMode);
        var offX = getOffset(item, 'x', viewportMode);
        var offY = getOffset(item, 'y', viewportMode);
        var isCta = item.classList.contains('hero-slider__cta');
        var ctaAlignmentMode = 'center';
        var ctaOffsetX = offX;

        applyTextAlignmentClass(item);

        var itemRect = item.getBoundingClientRect();
        var itemWidth = itemRect.width || 0;
        var itemHeight = itemRect.height || 0;

        if (isCta) {
          applyCtaSizeClass(item, viewportMode);
          ctaAlignmentMode = getCtaAlignmentMode(item, viewportMode);
          ctaOffsetX += getCtaAlignmentOffsetX(item, viewportMode);
          itemRect = item.getBoundingClientRect();
          itemWidth = itemRect.width || 0;
          itemHeight = itemRect.height || 0;
        }

        var minCenterX = itemWidth / 2;
        var maxCenterX = wrapWidth - itemWidth / 2;
        var minCenterY = itemHeight / 2;
        var maxCenterY = wrapHeight - itemHeight / 2;

        var targetCenterX = getTargetCenterX(alignmentMode, wrapWidth, itemWidth, offX);
        var targetCenterY = (wrapHeight / 2) + offY;

        if (isCta && sliderRect && sliderRect.width > 0 && sliderRect.height > 0) {
          var sliderTargetCenterY = (sliderRect.height / 2) + offY;
          var sliderToWrapX = sliderRect.left - wrapRect.left;
          var sliderToWrapY = sliderRect.top - wrapRect.top;

          minCenterX = (itemWidth / 2) + sliderToWrapX;
          maxCenterX = (sliderRect.width - (itemWidth / 2)) + sliderToWrapX;
          minCenterY = (itemHeight / 2) + sliderToWrapY;
          maxCenterY = (sliderRect.height - (itemHeight / 2)) + sliderToWrapY;

          targetCenterX = getTargetCenterX(ctaAlignmentMode, wrapWidth, itemWidth, ctaOffsetX);
          targetCenterY = sliderTargetCenterY + sliderToWrapY;
        }

        var clampedCenterX = wrapWidth / 2;
        var clampedCenterY = wrapHeight / 2;

        if (maxCenterX >= minCenterX) {
          clampedCenterX = clamp(targetCenterX, minCenterX, maxCenterX);
        }
        if (maxCenterY >= minCenterY) {
          clampedCenterY = clamp(targetCenterY, minCenterY, maxCenterY);
        }

        applyItemPositionClass(item, alignmentMode, isCta, ctaAlignmentMode, clampedCenterX, clampedCenterY);
      });

      scheduleReveal();
    }

    function scheduleApplyItemPositions() {
      if (positionRaf) {
        window.cancelAnimationFrame(positionRaf);
      }
      positionRaf = window.requestAnimationFrame(function () {
        positionRaf = null;
        applyItemPositions();
      });
    }

    function observePositioningElements() {
      if (typeof window.ResizeObserver !== 'function') return;

      positionResizeObserver = new window.ResizeObserver(function () {
        scheduleApplyItemPositions();
      });
      positionResizeObserver.observe(alignmentContainer);
      root.querySelectorAll('.hero-slider__item').forEach(function (item) {
        positionResizeObserver.observe(item);
      });
    }

    function showSlide(nextIndex) {
      activeIndex = (nextIndex + slides.length) % slides.length;
      sliderState[root.id] = activeIndex;
      root.classList.remove('hero-slider--positions-ready');
      root.classList.add('hero-slider--positions-pending');

      slides.forEach(function (slide, index) {
        slide.classList.toggle('hero__bg-slide--active', index === activeIndex);
      });

      contents.forEach(function (content, index) {
        content.classList.toggle('is-active', index === activeIndex);
      });

      dots.forEach(function (dot, index) {
        var isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      scheduleApplyItemPositions();
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || slides.length < 2) return;
      timer = window.setInterval(function () {
        showSlide(activeIndex + 1);
      }, intervalMs);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        showSlide(activeIndex - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        showSlide(activeIndex + 1);
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var targetIndex = parseInt(dot.getAttribute('data-hero-dot') || '0', 10);
        showSlide(targetIndex);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    if (isThemeEditor && !window.__heroSliderEditorEventsBound) {
      window.__heroSliderEditorEventsBound = true;
      document.addEventListener('shopify:block:select', function (event) {
        var target = event.target;
        var blockId = event.detail && event.detail.blockId;

        document.querySelectorAll('.hero.hero-slider').forEach(function (sliderRoot) {
          if (!target || !sliderRoot.contains(target)) return;
          var sliderId = sliderRoot.id;
          var state = window.__heroSliderState || {};
          var blockIndex = -1;
          var matchingContent = sliderRoot.querySelector('.hero-slider__content[data-block-id="' + blockId + '"]');
          if (matchingContent) {
            var parsed = parseInt(matchingContent.getAttribute('data-content-index') || '-1', 10);
            if (!isNaN(parsed)) blockIndex = parsed;
          }
          if (blockIndex >= 0) {
            state[sliderId] = blockIndex;
            sliderRoot.dispatchEvent(new CustomEvent('hero:show-slide', { detail: { index: blockIndex } }));
          }
        });
      });
    }

    root.addEventListener('hero:show-slide', function (event) {
      var idx = event.detail && typeof event.detail.index === 'number' ? event.detail.index : 0;
      showSlide(idx);
      stopAutoplay();
    });

    showSlide(activeIndex);
    startAutoplay();
    observePositioningElements();

    window.addEventListener('resize', scheduleApplyItemPositions);
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(scheduleApplyItemPositions).catch(function () {});
    }
  }

  function initAll(scope) {
    // Initialisiert direkte Section-Roots und nachgeladene Theme-Editor-Fragmente.
    var parent = scope || document;
    if (parent.matches && parent.matches('[data-a24-hero-slider]')) {
      init(parent);
    }
    if (parent.querySelectorAll) {
      parent.querySelectorAll('[data-a24-hero-slider]').forEach(init);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
}());
